import React from 'react'
import Icon from '../../../../atoms/Icon'

function AlwaysAvailableTag () {
  return (
    <div
      className='flex gap-sm radius-sm'
      style={{
        borderColor: 'var(--color-info-700)',
        borderWidth: '1px',
        borderStyle: 'solid',
        padding: 'var(--padding-xs) var(--padding-sm)',
        backgroundColor: 'var(--color-info-500)',
        color: 'var(--color-contrast-info-500)'
      }}
    >
      <Icon name='pin' style={{ fontSize: '16px' }} />
      <span>Always Available</span>
    </div>
  )
}

export default AlwaysAvailableTag
